<template>
  <form-wrap>
    <section-title v-t="'p.clientThemePage.title'"/>
    <form-field-set
      legend=""
      class="theme-editor"
    >
      <div
        v-for="(value, key) in themeVariables"
        :key="key"
        class="theme-editor__entry"
      >
        <swatches
          :value="themeColor(key)"
          :colors="colors"
          :swatch-size="32"
          row-length="6"
          shapes="circles"
          show-fallback
          fallback-ok-class="button-input"
          show-border
          @input="handleInput(key, $event)"
        />
        <span>{{ key }}</span>
      </div>

      <form-actions>
        <button-input
          v-t="'p.clientThemePage.btnSave'"
          type="button"
          @click="save"
        />
        <button-input
          v-t="'p.clientThemePage.btnReset'"
          type="button"
          color="grey"
          @click="reset"
        />
        <button-input
          v-t="'p.clientThemePage.btnLoadDefaults'"
          type="button"
          color="grey"
          @click="loadDefaults"
        />
      </form-actions>
    </form-field-set>
  </form-wrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Form, Notifications, Page } from '@/mixins'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'
import { CLIENT_DEFAULT_THEME } from '@/store/modules/clients/types'

export default {
  name: 'ThemeEditor',

  mixins: [
    Page,
    Form,
    Notifications
  ],

  components: {
    Swatches
  },

  computed: {
    ...mapState ({
      client: state => state.client,
      theme: state => state.clientTheme.data
    }),
    themeVariables () {
      return CLIENT_DEFAULT_THEME
    },
    colors () {
      const themeColorValues = Object.values(this.theme)
      return [...new Set(themeColorValues)]
    }
  },

  methods: {
    ...mapActions ({
      fetchCurrentUser: 'fetchCurrentUser',
      saveTheme: 'clientTheme/save',
      reloadTheme: 'clientTheme/load',
      updateThemeProperty: 'clientTheme/updateThemeProperty',
      apply: 'clientTheme/apply',
      loadDefaults: 'clientTheme/reset'
    }),

    themeColor(key) {
      const color = this.$store.state.clientTheme.data[key]
      return color === undefined
        ? CLIENT_DEFAULT_THEME[key]
        : color
    },

    handleInput (key, value) {
      this.updateThemeProperty({
        key: key,
        value: value
      })

      this.apply()
    },

    save () {
      this.saveTheme(this.client.id)
        .then(this.fetchCurrentUser)
        .then(this.savedNotification)
        .catch(this.somethingWentWrongNotification)
    },

    reset () {
      this.reloadTheme(this.client.id)
    }
  },
}
</script>

<style lang="sass">
@import '~styles/imports'
@import '~styles/forms/mixins'

.theme-editor
  &__entry
    display: flex
    padding: 12px
    align-items: center

    .vue-swatches
      margin-right: 10px

      &__fallback__wrapper
        display: flex
        justify-content: space-between
        margin: 0!important
        padding: 0 8px 8px 8px!important
        width: auto!important

      &__fallback__input--wrapper
        flex-grow: 1

      &__fallback__input
        @extend %form-text-input-style
        height: rem-calc(42)
        width: rem-calc(130)

      &__fallback__button
        width: rem-calc(80)

      &__trigger
        display: block
</style>




// WEBPACK FOOTER //
// src/components/clients/ThemeEditor.vue